import { allThemes, Box, BoxProps, ColorOptions, TextInput, TextInputProps } from '@jfs/ui-new'
import { FC, ReactElement, useState } from 'react'

interface TellusProps {
  value?: string
  editable?: boolean
  placeHolder?: string
  differedTitle?: string | undefined // Use in case place holder and title need to be different
  multiline?: boolean
  onChangeText?: (value: string) => void
  onBlur?: () => void
  onChange?: void
  hideText?: boolean
  animate?: boolean
  fieldName?: string
  error?: string
  touched?: boolean
  disabled?: boolean
  setFieldValue?: (field: string, value: string | number) => void
  isSubmitting?: boolean
  rightView?: ReactElement | null
  maxLength?: number
  testID?: string
  helperText?: string
  onTextChanged?: (data: string) => void
  bottomView?: ReactElement | null
  autoFocus?: boolean
  floatingLabel?: string
  handleFocus?: () => void
}

const TellUsInput: FC<TellusProps> = ({
  value,
  editable = true,
  multiline = true,
  placeHolder = '',
  onChangeText,
  setFieldValue,
  hideText,
  testID,
  fieldName,
  maxLength,
  onTextChanged,
  autoFocus = false,
  handleFocus,
  onBlur,
}: TellusProps) => {
  const [isFocused, setFocused] = useState(false)
  const handleOnFocus = (): void => {
    setFocused(true)
    if (handleFocus) {
      handleFocus()
    }
  }

  const handleOnBlur = (): void => {
    setFocused(false)
    if (onBlur) {
      onBlur()
    }
  }

  const handleOnChangeText = (text: string): void => {
    if (onTextChanged) {
      onTextChanged(text)
    }
    if (onChangeText) {
      onChangeText(text)
    }
    if (setFieldValue && fieldName) {
      setFieldValue(fieldName, text)
    }
  }

  const borderColor = isFocused
    ? ('PRIMARY' as ColorOptions)
    : (allThemes.newThemeDark.colors.DISABLED_GREY as ColorOptions)
  return (
    <Box {...styles.tfWrapper}>
      <TextInput
        value={value}
        testID={testID}
        placeholder={placeHolder}
        editable={editable}
        bottomLineColor="TRANSPARENT"
        onFocusBottomLineColor="TRANSPARENT"
        placeholderTextColor="LIGHT_GREY"
        {...styles.input(borderColor)}
        onFocus={handleOnFocus}
        onBlur={handleOnBlur}
        onChangeText={handleOnChangeText}
        secureTextEntry={hideText}
        multiline={multiline}
        maxLength={maxLength}
        minHeight={90}
        numberOfLines={3}
        autoFocus={autoFocus}
        accessibilityLabel="input"
      />
    </Box>
  )
}

const styles = {
  input: (borderColor: ColorOptions) =>
    ({
      borderWidth: 1,
      borderColor: borderColor,
      borderRadius: 8,
      fontSize: 13,
      padding: 16,
      fontWeight: '500',
      outline: 'none',
      lineHeight: 21,
    } as TextInputProps),
  tfWrapper: {
    borderWidth: 1,
    borderRadius: 6,
    borderColor: 'DISABLED_GREY',
  } as BoxProps,
}

export default TellUsInput
